module.exports = __webpack_public_path__ + "static/8-woman-f34bfea4a2ae6753748d352c7d21f728.jpg";